// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1AifL","title":"BackImages_title__2ER2e","images":"BackImages_images__Z6zFz"};